import * as actionTypes from "./actionTypes";
import axios from "../../axios-amps";
import { logFirebaseEvent } from "../../shared/utility";
import { serverconfigs } from "../../constants";

export const submitBalanceBillingClaimStarted = () => {
  return {
    type: actionTypes.SUBMIT_BALANCE_BILLING_CLAIM_STARTED,
  };
};
export const submitBalanceBillingClaimSuccess = () => {
  return {
    type: actionTypes.SUBMIT_BALANCE_BILLING_CLAIM_SUCCESS,
  };
};
export const submitBalanceBillingClaimFailed = (errorMessage) => {
  return {
    type: actionTypes.SUBMIT_BALANCE_BILLING_CLAIM_FAILED,
    errorMessage: errorMessage,
  };
};

export const resetSubmitBalanceBillingClaim = () => {
  return {
    type: actionTypes.RESET_SUBMIT_BALANCE_BILLING_CLAIM,
  };
};

export const submitBalanceBillingClaim = (submitClaim: {
  procedureLabel: string;
  claimId: number;
  patientId: number;
  dateOfService: string;
  facility: string;
  totalChargeAmount: number;
  document: {
    id: string;
  }[];
}) => {
  return (dispatch) => {
    dispatch(submitBalanceBillingClaimStarted());
    axios
      .post(serverconfigs.fetchBBClaimDetailsUrl+`/`, submitClaim)
      .then((response) => {
        console.log(response.data);
        dispatch(submitBalanceBillingClaimSuccess());
      })
      .catch((error) => {
        if (error.statusCode === 400) {
          logFirebaseEvent("Exception400");
        } else if (error.statusCode === 401) {
          logFirebaseEvent("Exception401");
        } else if (error.statusCode === 500) {
          logFirebaseEvent("Exception500");
        }
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          if (error.response.data.statusCode === 409) {
            if (
              error.response.data.message.find((err) =>
                err.toLowerCase().match(/combination already exists/g)
              )
            ) {
              dispatch(submitBalanceBillingClaimSuccess());
            } else dispatch(submitBalanceBillingClaimFailed(error.message));
          }
        } else dispatch(submitBalanceBillingClaimFailed(error.message));
      });
  };
};
